module.exports = __webpack_public_path__ + "static/media/import-properties.7ffaf321.png";